// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__YP+9F","vInfoDiv":"courses-page_vInfoDiv__sLet4","editBtn":"courses-page_editBtn__GDSQ6","addBtn":"courses-page_addBtn__lrWW1"};